module.exports = __webpack_public_path__ + "media/images/logo-text-4da1a6c17685f1e86896bc44bd55244f.svg";